import React from "react";
import { Input } from "antd";
import { handleApiError } from "src/utils/errors";

function FPNCard({ saveFacility, facility, user }) {
  const updateData = () => async (e) => {
    if (e.target.value) {
      const fpn = e.target.value.trim();
      try {
        await saveFacility({ facilityId: user._id, federalProviderNumber: fpn });
      } catch (error) {
        handleApiError(error);
      }
    }
  };

  return (
    <>
      <div>
        {/* FIXME: Automatically disabled during ESLint config update */}
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label style={{ display: "inline-block", minWidth: 180 }}>Federal Provider Number</label>
        &nbsp;
        <Input
          defaultValue={facility?.federalProviderNumber}
          placeholder="Federal Provider Number"
          /* @ts-expect-error FIXME this wrong type */
          rows={1}
          /* @ts-expect-error FIXME this wrong type */
          onChange={updateData("covidData.federalProviderNumber")}
        />
      </div>
    </>
  );
}

export { FPNCard };
